import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { WE_CARE, PLAN401 } from "../../StaticData/aboutus";
import faq from "../../assets/images/faq.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const WeCare = () => {
  return (
    <div className="WeCare-page">
      <Helmet>
        <title>We Care About Our Employees | Idexcel</title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
      <Container fluid className="we-care-banner-container p-0">
        <section className="we-care-banner-section"></section>
      </Container>
      </motion.div>
      
      <Row
        className="p-0 m-0 content px-2 px-lg-5"
        style={{ background: "#eee" }}
      >
        <Container className="px-lg-5 mb-5">
          <Row className="p-0 m-0 px-2 px-lg-4">
            <h2 className="text-center mb-4 section-title">
              Our <span className="textgrad"> Benefits </span>
            </h2>
          </Row>
          <section className="m-0 p-0">
            <Row className="p-0 m-0 px-2 px-lg-4">
              <h3 className="fs-5 fw-semibold mb-3">
                Equal Employment Opportunity
              </h3>
              <p className="py-1 ">
                Idexcel is an Equal Employment Opportunity employer. This
                meaning, we recruit, hire, compensate, train, promote, transfer,
                and administer all terms and conditions of employment without
                regard to their race, color, religion, national origin, sex,
                sexual orientation, gender identity, age, protected veteran
                status, disability, or other protected categories under the
                applicable law.
              </p>
              <p className="py-1 my-2">
                Idexcel will not tolerate any unlawful discrimination against
                any applicant or employee and any such conduct is expressly
                prohibited.
              </p>
            </Row>
          </section>
          <section className="m-0 p-0 mt-4 we-care">
            <Row className="p-0 m-0 px-2 px-lg-4">
              <h3 className="fs-5 fw-semibold mb-3">
                WE CARE ABOUT OUR EMPLOYEES
              </h3>
              <h4 className="fs-5 fw-semibold mb-3">
                Medical, Dental & Vision Insurance Coverage
              </h4>
              <p className="py-1">
                You are eligible to enroll in Idexcel’s medical, dental, vision
                plans on your very first day of full time employment. You will
                need to apply within your first 30 days of employment or during
                the annual open enrollment period.
              </p>
              {WE_CARE?.map((wecare, index) => {
                return (
                  <div
                    className="m-0 p-0 my-3 px-3 py-4 bg-white d-flex flex-column flex-xl-row align-xl-items-center  align-items-start"
                    key={index}
                    style={{ boxShadow: "0px 0px 30px rgba(73, 78, 92, 0.15)" }}
                  >
                    <div className="benefits-img-wrap-1 col-xl-1 my-xl-4 mx-xl-4">
                      <img src={wecare?.img} />
                    </div>
                    <div>
                      <h2 className="fs-5 fw-bold mt-3">{wecare?.title}</h2>
                      <p className="py-1 ">{wecare?.desc}</p>
                    </div>
                  </div>
                );
              })}
            </Row>
          </section>
          <section className="m-0 p-0 mt-4 we-care pb-5">
            <Row className="p-0 m-0 px-2 px-lg-4 pb-4">
              <h1 className=" textgrad mb-4">401(k) Plan</h1>
              <p className="">
                At Idexcel, you are eligible to join our 401(k) plan immediately
                and save for your retirement using pre-tax dollars.
              </p>
              {PLAN401?.map((wecare, index) => {
                return (
                  <div
                    className="m-0 p-0 my-3 px-3 py-4 bg-white  d-flex flex-column flex-xl-row align-xl-items-center  align-items-start"
                    key={index}
                    style={{ boxShadow: "0px 0px 30px rgba(73, 78, 92, 0.15)" }}
                  >
                    <div className="benefits-img-wrap-2 col-xl-1 mx-xl-4">
                      <img src={wecare?.img} />
                    </div>
                    <div>
                      <h2 className="fs-5 fw-bold mt-3">{wecare?.title}</h2>
                      <p className="py-1 ">{wecare?.desc}</p>
                    </div>
                  </div>
                );
              })}
              <div
                className="m-0 p-0 my-3 px-3 py-4 bg-white d-flex flex-column flex-xl-row align-items-xl-center  align-items-start"
                style={{ boxShadow: "0px 0px 30px rgba(73, 78, 92, 0.15)" }}
              >
                <div className="benefits-img-wrap-3 col-xl-1 mx-xl-4 mb-3">
                  <img src={faq} />
                </div>
                <div>
                  <a
                    href="/careers/we-care-about-our-employees/faqs"
                    className="fs-5 text-danger fw-bold textDecoration"
                  >
                    FAQ
                  </a>
                </div>
              </div>
            </Row>
          </section>
        </Container>
      </Row>
    </div>
  );
};

export default WeCare;
